export default "__VITE_PUBLIC_ASSET__5c6cf228__"